// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';
import type { TaskId } from '../../../tasks/constants.tsx';
import { dispatchEvent } from '../dispatch-event/dispatch-event.tsx';

export const completeTask =
	({ id }: { id: TaskId }): Action<State> =>
	async ({ getState, setState, dispatch }) => {
		const { tasks } = getState();

		if (!tasks) {
			return;
		}

		let isDirty = false;

		const modifiedTasks = tasks.items.map((task) => {
			if (task.id === id && !task.completed) {
				isDirty = true;
				return { ...task, completed: true };
			}
			return task;
		});

		if (!isDirty) {
			return;
		}

		setState({ tasks: { ...tasks, items: modifiedTasks } });
		dispatch(dispatchEvent({ type: 'task-completed', taskId: id }));
	};
